import classNames from 'classnames';
import React from 'react';
import styles from './SelectBox.scss';

interface SelectOption {
    value: string;
    name: string;
}

interface SelectBoxProps extends React.InputHTMLAttributes<HTMLSelectElement> {
    /**Unique id of the component */
    id: string;
    /**Label that appears on top of the input field */
    label: string;
    options: SelectOption[];
    appearance?: 'light' | 'dark';
}

const SelectBox = (props: SelectBoxProps) => {
    const {
        id,
        label,
        options,
        appearance = 'dark',
        ...selectProps
    } = props;

    return (
        <div className={classNames(styles.selectbox, styles[`selectbox--appearance-${appearance}`])}>
            <label htmlFor={id} className={styles.selectbox__label}>{label}</label>
            <select
                id={id}
                className={styles.selectbox__input}
                {...selectProps}>
                <option label="" hidden disabled></option>
                {options.map(({ value, name }) => (
                    <option key={name.split(' ').join('-')} value={value}>{name}</option>
                ))}
            </select>
        </div>
    )
}

export default SelectBox;
